import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

//////////////////////////////////////////////////////
import {connect} from 'react-redux';
import Keycloak from 'keycloak-js';
import jwt from 'jsonwebtoken';


import { LayoutDashboard } from "../layouts/LayoutDashboard";

//Actions
import {SetKeyCloak} from '../actions/keyCloakAction'
import {getAllCommunities, getCommunityById} from '../actions/communityActions'
//////////////////////////////////////////////////////////////

// let history=null;
// let dispatch = null;

const keycloak = Keycloak('../keycloak.json');

const JWT_AUTHTOKENEXPIRE  = 2592000;
const JWT_AUTHSESSIONEXPIRE = 31536000;
const JWT_SECRET = 'device2a$10$Cr8HVOh6mhzLSKkBQbm5pu';

const generateToken = (ky, email, userName, communityId) => {
  if (ky !== undefined) {
  try {
          var d = new Date();
          d.setSeconds(d.getSeconds() + JWT_AUTHTOKENEXPIRE);
          var crntEpoch = Math.floor(Date.now() / 1000);
          // For Session expire. Currently set to 1 years. Not useful now
          var expSession = crntEpoch + JWT_AUTHSESSIONEXPIRE;
          // Token Expire Time. Refresh_token will be implemented based on expSession and expiresToken
          var expiresToken = crntEpoch + JWT_AUTHTOKENEXPIRE;

          var token = jwt.sign({
              communityId:communityId,
              userId: email,
              userName: userName,
              userFunction: 'CMS',
              expSession: expSession,
              expiresIn: expiresToken
          }, JWT_SECRET, { expiresIn: expiresToken });
          return token;
      } catch (err) {
          if (err) {
              var error = err.developerMessage = "Error in generating  token" + err.message;
//                log.error(error, "Error in Token ");
              return error;
          }
      }
  }
};

class AppRouter extends Component{
  constructor(props){
    super(props);

    this.state={
      keycloak:null,
      authenticated: false,
      super: false,
      communityId: "",
      token: ""
    }

  }


  async componentDidMount(){

    try {

      await keycloak.init({ onLoad: 'login-required','checkLoginIframe' : false, promiseType: 'native'})
      .then(async (authenticated) => {
        if (authenticated) { 
          let some= {}
        await keycloak.loadUserProfile().then (
          function (userDetails){
            some = userDetails
            
            localStorage.setItem('ky', JSON.stringify(keycloak));
            localStorage.setItem('userName', keycloak.profile.username);
              //var d = keycloak.tokenParsed
              if (userDetails.attributes.length === 0) {
                  if (keycloak !== undefined) {
                      keycloak.logout();
                      keycloak.setAuthThing(undefined);
                      keycloak.setAuthenticated(false); 
                     localStorage.clear();
                  } else {
                    window.location.href = '/';
                  }
              }     
          });

        if (some.attributes.admin === undefined) {
          localStorage.setItem('communityId', some.attributes.communityId);
          localStorage.setItem('superAdmin', false);
          localStorage.setItem('token', generateToken(keycloak,some.email, some.username, some.attributes.communityId))


        } else {
          // localStorage.setItem('communityId', "");
          localStorage.setItem('superAdmin', some.attributes.admin);
          localStorage.setItem('token', generateToken(keycloak,some.email, some.username, ""))

        }
          this.props.SetKeyCloak(keycloak)

          this.setState({keycloak: keycloak, authenticated: authenticated});

         
      }


      
      this.GetAllCommunities();
      // history.replace("/home");
    })
      
    } catch (error) {
      localStorage.clear();
    }
  };// ComponentDidMount

  GetAllCommunities = () =>{
    if (localStorage.getItem('superAdmin') === "false"){

        this.props.getCommunityById(localStorage.getItem('communityId'))
    }
    else{

        this.props.getAllCommunities()
    }

};

  handleLogin = () => {
    // dispatch({
    //   type: types.login,
    //   payload: {
    //     name: "Admin",
    //   },
    // }
    // );

    // history.replace("/home");
  };
  
  render(){


     

    if(this.state.keycloak){
      if(this.state.authenticated ){

        return(
          <React.Fragment>
            <Router>
              <Switch>
                <Route path="/" component={LayoutDashboard} />
              </Switch>
            </Router>
          </React.Fragment>
        );
      } else {
         return(
          <div className="readmin-panel">
            <div className="page_header col-12">
                <div className="col-sm-4 useful_btns"></div>
                <div className="col-sm-12 login-logo ">
                    Unable to authenticate!
                    <hr/>
                </div>
            </div>
          </div>
          );
      }
    }
    return (
      <div className="readmin-panel">
        <div className="page_header col-12">
            <div className="col-sm-4 useful_btns">
            </div>
            <div className="col-sm-12 login-logo ">
                One Moment please
                <hr/>
            </div>
          </div>
      </div>
    );
  }
}

function mapStateToProps(state){
  return {    }
};


export  default connect(mapStateToProps,{SetKeyCloak, getAllCommunities, getCommunityById})(AppRouter); 
